export const prefixNumberSign = (value) => {
  const number = parseInt(value, 10);
  if (isNaN(number)) {
    return value;
  }

  return number > 0 ? `+${number}` : `${number}`;
};
